import { Component, Input } from '@angular/core';

@Component({
	selector: 'ui-timeentry-approval-status',
	template: `
		<div *ngIf="approval_status" class="text-center">
			<div>
				<span style="text-transform: uppercase;" class="badge bg-{{getStatusColor()}}-25 text-{{getStatusColor()}} text-bold">{{approval_status}}</span>
			</div>
		</div>
	`
})
export class UITimeEntryApprovalStatusComponent {

	@Input() approval_status;

	status_map = {};

	constructor(
	) {
		this.status_map['Awaiting Approval'] = { color: 'warning' };
		this.status_map['Approved'] = { color: 'success' };
		this.status_map['Declined'] = { color: 'primary' };
	}

	getStatusColor(): string {
		return this.status_map[this.approval_status].color || 'secondary';
	}

}
